<template>
  <label :class="wrpClass">
    <span class="bcc-radio-input">
      <i class="bcc-radio-inner"></i>
      <input type="radio"
        ref="radio"
        :value="label"
        v-model="model"
        aria-hidden="true"
        @change="handleChange"
        :disabled="isDisabled">
    </span>
    <span class="bcc-radio-label">
      <slot></slot>
      <template v-if="!$slots.default">{{label}}</template>
    </span>
  </label>
</template>
<script>
import Emitter from '../../mixins/emitter'
const prefixCls = 'bcc-radio'

export default {
  name: 'BccRadio',
  mixins: [Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    label: {
      type: [String, Number, Boolean],
      default: true
    }
  },
  computed: {
    wrpClass () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-disabled`]: this.isDisabled,
          [`${prefixCls}-checked`]: this.isChecked
        }
      ]
    },
    model: {
      get () {
        return this.isGroup ? this.isGroup.value : this.value
      },
      set (val) {
        if (this.isGroup) {
          this.dispatch('BccRadioGroup', 'input', val)
        } else {
          this.$emit('input', val)
        }
      }
    },
    isChecked () {
      return this.model === this.label
    },
    isDisabled () {
      return this.isGroup ? this.isGroup.disabled || this.disabled : this.disabled
    },
    isGroup () {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'BccRadioGroup') {
          parent = parent.$parent
        } else {
          return parent
        }
      }
      return false
    }
  },
  methods: {
    handleChange (ev) {
      // 等待model set 执行结束
      this.$nextTick(() => {
        this.$emit('on-change', this.model, ev)
        this.isGroup && this.dispatch('BccRadioGroup', 'on-change', this.model)
      })
    }
  }
}
</script>
